module.exports = __webpack_public_path__ + "static/media/Faculty-pub-qual.c2cf3515.png";